import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import DefinitionListHeader from './DefinitionListHeader';
import { sortUrl, parse, toSortOrder } from '../../../../../utils/UrlUtil';
import Paginator from '../../../../../components/Paginator';
import { getUserLanguage } from '../../../../../utils/LanguageUtil';
import { intlShape } from '../../../../../components/prop-types';

const messages = defineMessages({
  name: {
    id: 'attrs.name',
    defaultMessage: 'name',
  },
  email: {
    id: 'attrs.email',
    defaultMessage: 'Email',
  },
  gender: {
    id: 'attrs.gender',
    defaultMessage: 'Gender',
  },
  locale: {
    id: 'attrs.locale',
    defaultMessage: 'Preferred language',
  },
  respondentType: {
    id: 'export.respondent.type',
    defaultMessage: 'Respondent Type',
  },
  M: {
    id: 'attrs.gender.M',
    defaultMessage: 'Male',
  },
  F: {
    id: 'attrs.gender.F',
    defaultMessage: 'Female',
  },
  U: {
    id: 'attrs.gender.U',
    defaultMessage: 'Unspecified',
  },
});

const nameTemplate = (rowData) => {
  const { firstName = '', lastName = '' } = rowData;
  return `${firstName} ${lastName}`;
};

const languageTemplate = (rowData, col) => {
  const language = getUserLanguage(rowData.locale, col.translatedTags);
  return language.label;
};

const respondentTypeTemplate = (rowData) => {
  if (rowData.ownEmployee) {
    return (
      <FormattedMessage
        id="attrs.candidateType.INTERNAL"
        defaultMessage="Internal Employee"
      />
    );
  }
  return (
    <FormattedMessage
      id="attrs.candidateType.EXTERNAL"
      defaultMessage="External Respondent"
    />
  );
};

const genderTemplate = (rowData, { formatMessage }) => formatMessage(messages[rowData.gender]);

class JobProfileList extends Component {
  constructor(props) {
    super(props);
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(event) {
    const { location, history } = this.props;
    sortUrl(event, location, history);
  }

  render() {
    const {
      connection: {
        edges, totalCount, indexFrom, indexTo, pageInfo,
      },
      intl: { formatMessage },
      currentAccount,
      loading,
      location,
      translatedTags,
    } = this.props;

    // data list
    const listRows = edges.map(({ node }) => ({
      ...node,
    }));
    const params = parse(location.search);
    const { sort = {} } = params;
    const { sortBy, sortDir } = sort;

    // header
    const nameHeader = formatMessage(messages.name);
    const emailHeader = formatMessage(messages.email);
    const genderHeader = formatMessage(messages.gender);
    const localeHeader = formatMessage(messages.locale);
    const respondentTypeHeader = formatMessage(messages.respondentType);

    // footer
    const footer = <Paginator totalCount={totalCount} indexFrom={indexFrom} indexTo={indexTo} pageInfo={pageInfo} />;

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <DefinitionListHeader />
            <DataTable
              value={listRows}
              footer={footer}
              responsive
              sortField={sortBy}
              sortOrder={toSortOrder(sortDir)}
              onSort={this.onSortChange}
              lazy
              loading={loading}
            >
              <Column
                field="name"
                header={nameHeader}
                currentAccount={currentAccount}
                body={nameTemplate}
                keyField="id"
                displayField="name"
              />
              <Column field="email" header={emailHeader} />
              <Column
                field="gender"
                header={genderHeader}
                body={genderTemplate}
                formatMessage={formatMessage}
              />
              <Column
                field="locale"
                header={localeHeader}
                body={languageTemplate}
                translatedTags={translatedTags}
              />
              <Column
                field="ownEmployee"
                header={respondentTypeHeader}
                body={respondentTypeTemplate}
              />
            </DataTable>
          </div>
        </div>
      </div>
    );
  }
}

JobProfileList.propTypes = {
  connection: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default withRouter(injectIntl(JobProfileList));
